const dataCheckWrapper = document.querySelector('.delivery-check--wrapper');
const dataInfoWrapper = document.querySelector('.delivery-info--wrapper');
const dataUnavailableWrapper = document.querySelector('.delivery-unavailable');
const pinCodeForm = document.getElementById('pincode-form');
const cutoffWrapper = document.getElementById('cutoff-wrapper');
const dateWrapper = document.getElementById('date-wrapper');
const successMSG = document.querySelector('.delivery-check__success-message');
const successMSGBottom = document.querySelector('.delivery-check__success-message-bottom');
const priceWrapper = document.querySelector('.price-wrapper');
const priceCon = priceWrapper.querySelector('span.price-con');
let previousPin = null;

pinCodeForm.addEventListener('submit', async (event) => {
  event.preventDefault();

  const pinCodeValue = document.getElementById('pinInput').value;
  if (pinCodeValue !== previousPin) {
    cutoffWrapper.innerHTML = '';
    dateWrapper.innerHTML = '';

    const formData = {
      postal_code: pinCodeValue,
    };
    const jsonData = JSON.stringify(formData);



    try {
      const response = await fetch(
        `https://tortuga-oms--development.gadget.app/shipping/windows/list?postcode=${pinCodeValue}&tenancy=macro-store1.myshopify.com&context=website_checker`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();
      const rates = data.rates;

      if (rates.length > 0) {
        dataInfoWrapper.classList.remove('hidden');
        successMSG.classList.remove('hidden');
        successMSGBottom.classList.remove('hidden');
        priceWrapper.classList.remove('hidden');
        priceCon.innerHTML = (parseFloat(data.rates[0].price / 100)).toFixed(2);

        rates.forEach((rate) => {

          const shippingDateStart = new Date(`${rate.shippingDateETA}T${rate.shippingWindowStart}:00`);
          const shippingDateEnd = new Date( `${rate.shippingDateETA}T${rate.shippingWindowEnd}:00`);
          const cutoffDate = new Date(rate.cutoffISO);
          let timezoneString = '';

          if(rate.cutoffISO.split('+')?.[1] == '10:00') {
            timezoneString = 'AEST'
          } else {
            timezoneString = 'AEDT'
          }

          const cutoffDateStr = `${dateFns.format(cutoffDate, 'ccc d MMM')} ${timezoneString}`
          const cutoffTimeStr = `${dateFns.format(cutoffDate, 'haaa')} ${timezoneString}`

          const shippingDateStr = `${dateFns.format(shippingDateStart, 'ccc d MMM')}`
          const shippingTimeStr = `${dateFns.format(shippingDateStart, 'haaa')} to ${dateFns.format(shippingDateEnd, 'haaa')}`

          const cutoffDiv = document.createElement('div');
          cutoffDiv.classList.add('delivery-column');
          // cutoffDiv.textContent = getFirstThreeWords(rate.cutoff);
          // cutoffDiv.textContent = rate.cutoff;
          const cutoffP1 = document.createElement('p');
          cutoffP1.classList.add('delivery-date');
          cutoffP1.textContent = cutoffDateStr;
          cutoffDiv.appendChild(cutoffP1);
          const cutoffP2 = document.createElement('p');
          cutoffP2.classList.add('delivery-time');
          cutoffP2.textContent = cutoffTimeStr;
          cutoffDiv.appendChild(cutoffP2);

          cutoffWrapper.appendChild(cutoffDiv);


          const deliveryDiv = document.createElement('div');
          deliveryDiv.classList.add('delivery-column');
          const deliveryP1 = document.createElement('p');
          deliveryP1.classList.add('delivery-date');
          deliveryP1.textContent = shippingDateStr;
          deliveryDiv.appendChild(deliveryP1);
          const deliveryP2 = document.createElement('p');
          deliveryP2.classList.add('delivery-time');
          deliveryP2.textContent = shippingTimeStr;
          deliveryDiv.appendChild(deliveryP2);

          dateWrapper.appendChild(deliveryDiv);
        });
      } else {
        dataCheckWrapper.classList.add('hidden');
        dataUnavailableWrapper.classList.remove('hidden');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      previousPin = pinCodeValue;
    }
  }
  pinCodeForm.addEventListener('input', (e) => {
    e.preventDefault();
    successMSG.classList.add('hidden');
    successMSGBottom.classList.add('hidden');
    priceWrapper.classList.add('hidden');
    dataInfoWrapper.classList.add('hidden');
    previousPin = '';
  });
});

function getFirstThreeWords(inputString) {
  return inputString.split(/\s+/).slice(0, 3).join(' ');
}
function getStringAfterThreeWords(inputString) {
  return inputString.split(/\s+/).slice(3).join(' ');
}

// const pinCodeRequestForm = document.querySelector('form#pincode-request-form');
// pinCodeRequestForm.addEventListener('submit', (event) => {
//   event.preventDefault();
// });
